import { PairedCostRouteItem } from '@aloft/toolkit-shared';

import { routeToStepMap, VALIDATION_STEP_LABELS } from '../../../hooks/validation/consts.ts';

export const getAlertPageLabel = (page: PairedCostRouteItem): string =>
  VALIDATION_STEP_LABELS[routeToStepMap[page]!];
